import { CalculatorPrefillResultEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { ShowSnackbarVariant } from "web_myplann/Utils/WebViewModel";

type CalculatorPrefillSnackbar = {
	textKey: typeof Resources.EventAlert.CalculatorPrefill.transferFailed;
	variant: ShowSnackbarVariant;
};

export const getCalculatorPrefillSnackbar = (
	result: CalculatorPrefillResultEnum,
): CalculatorPrefillSnackbar | null => {
	switch (result) {
		case CalculatorPrefillResultEnum.TransferFailed:
			return {
				textKey: Resources.EventAlert.CalculatorPrefill.transferFailed,
				variant: "error",
			};
		case CalculatorPrefillResultEnum.NotFromNsure:
			return {
				textKey: Resources.EventAlert.CalculatorPrefill.notTransferable,
				variant: "error",
			};
		default:
			return null;
	}
};
